// eslint-disable-next-line import/prefer-default-export
export const AdminSidePanelAction = Object.freeze({
    None: 0,
    Create: 1,
    Edit: 2,
    Duplicate: 3,
});
